document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const menuDrawer = document.querySelector('[data-menu-drawer]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const menuBackdrop = document.querySelector('.drawer-backdrop');
  const cartBackdrop = document.querySelector('.cart-backdrop');
  const toggle = (el, state, backdrop) => { if(!el) return; el.classList.toggle('is-open',state); el.setAttribute('aria-hidden',String(!state)); backdrop?.classList.toggle('is-open',state); body.classList.toggle('no-scroll',state); };
  document.querySelector('[data-menu-open]')?.addEventListener('click',()=>toggle(menuDrawer,true,menuBackdrop));
  document.querySelectorAll('[data-menu-close]').forEach(btn=>btn.addEventListener('click',()=>toggle(menuDrawer,false,menuBackdrop)));
  document.querySelectorAll('[data-cart-open]').forEach(btn=>btn.addEventListener('click',()=>{
    if(window.matchMedia('(max-width: 767px)').matches){window.location.href=btn.dataset.cartUrl||'/cart';return;}
    toggle(cartDrawer,true,cartBackdrop);
  }));
  document.querySelectorAll('[data-cart-close]').forEach(btn=>btn.addEventListener('click',()=>toggle(cartDrawer,false,cartBackdrop)));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){toggle(menuDrawer,false,menuBackdrop);toggle(cartDrawer,false,cartBackdrop);}});

  document.querySelectorAll('[data-object-slider]').forEach(slider => {
    const track=slider.querySelector('[data-slider-track]');
    const cards=[...slider.querySelectorAll('[data-product-card]')];
    const prev=slider.querySelector('[data-slider-prev]');
    const next=slider.querySelector('[data-slider-next]');
    const prevPeek=slider.querySelector('[data-slider-prev-peek]');
    const nextPeek=slider.querySelector('[data-slider-next-peek]');
    const current=slider.querySelector('[data-slider-current]');
    const dots=[...slider.querySelectorAll('[data-slide-index]')];
    if(!track || cards.length<2) return;
    const indexNow=()=>{const center=track.scrollLeft+track.clientWidth*.08;let best=0,dist=Infinity;cards.forEach((card,i)=>{const d=Math.abs(card.offsetLeft-center);if(d<dist){dist=d;best=i;}});return best;};
    const update=()=>{const i=indexNow();dots.forEach((d,j)=>d.classList.toggle('is-active',i===j));if(current)current.textContent=String(i+1);if(prev)prev.disabled=i===0;if(next)next.disabled=i===cards.length-1;if(prevPeek)prevPeek.hidden=i===0;if(nextPeek)nextPeek.hidden=i===cards.length-1;};
    const go=i=>{const card=cards[Math.max(0,Math.min(cards.length-1,i))];track.scrollTo({left:card.offsetLeft,behavior:'smooth'});};
    prev?.addEventListener('click',()=>go(indexNow()-1));next?.addEventListener('click',()=>go(indexNow()+1));prevPeek?.addEventListener('click',()=>go(indexNow()-1));nextPeek?.addEventListener('click',()=>go(indexNow()+1));dots.forEach(d=>d.addEventListener('click',()=>go(Number(d.dataset.slideIndex))));track.addEventListener('scroll',()=>requestAnimationFrame(update),{passive:true});update();
  });

  document.querySelectorAll('[data-quick-add]').forEach(button=>button.addEventListener('click',async e=>{e.preventDefault();e.stopPropagation();const id=button.dataset.variantId;if(!id||button.disabled)return;button.disabled=true;try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});if(!r.ok)throw new Error();const cart=await fetch('/cart.js').then(r=>r.json());document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);button.innerHTML='<span aria-hidden="true">✓</span>';button.setAttribute('aria-label','Ajouté au panier');}catch(err){window.location.href='/cart';}finally{button.disabled=false;}}));

  const acc=[...document.querySelectorAll('[data-footer-accordion]')];const mq=matchMedia('(min-width:768px)');const sync=()=>acc.forEach(x=>x.open=mq.matches);sync();mq.addEventListener?.('change',sync);
});

/* Shopify Theme Editor: reload section interactions after live edits. */
document.addEventListener('shopify:section:load', () => window.location.reload());

/* Panier ADV4 — contrôles de quantité tactiles avec mise à jour fluide. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cart-page]').forEach(cartPage => {
    const form = cartPage.querySelector('.cart-form');
    const updateButton = cartPage.querySelector('.cart-update');
    let updateTimer;
    const scheduleUpdate = () => {
      clearTimeout(updateTimer);
      updateTimer = setTimeout(() => form?.requestSubmit(updateButton), 420);
    };
    cartPage.querySelectorAll('.cart-quantity').forEach(control => {
      const input = control.querySelector('[data-cart-quantity]');
      control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        input.value = Math.max(0, Number(input.value || 0) - 1);
        scheduleUpdate();
      });
      control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        input.value = Number(input.value || 0) + 1;
        scheduleUpdate();
      });
      input?.addEventListener('change', scheduleUpdate);
    });
  });
});

/* V6 — galerie produit uniforme + barre d'ajout mobile */
(() => {
  const initProductUX = () => {
    document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      if (gallery.dataset.adv4Ready === 'true') return;
      gallery.dataset.adv4Ready = 'true';
      const track = gallery.querySelector('[data-product-gallery-track]');
      const slides = [...gallery.querySelectorAll('[data-product-gallery-slide]')];
      const dots = [...gallery.querySelectorAll('[data-product-gallery-dot]')];
      const current = gallery.querySelector('[data-product-gallery-current]');
      if (!track || slides.length < 2) return;

      const getIndex = () => {
        let index = 0;
        let distance = Infinity;
        const x = track.scrollLeft;
        slides.forEach((slide, i) => {
          const d = Math.abs(slide.offsetLeft - x);
          if (d < distance) { distance = d; index = i; }
        });
        return index;
      };
      const update = () => {
        const i = getIndex();
        if (current) current.textContent = String(i + 1);
        dots.forEach((dot, j) => dot.classList.toggle('is-active', i === j));
      };
      dots.forEach(dot => dot.addEventListener('click', () => {
        const slide = slides[Number(dot.dataset.index || 0)];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }));
      let raf = null;
      track.addEventListener('scroll', () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });
      update();
    });

    document.querySelectorAll('[data-main-product]').forEach(root => {
      if (root.dataset.adv4ProductReady === 'true') return;
      root.dataset.adv4ProductReady = 'true';
      const form = root.querySelector('.product-form');
      const submit = root.querySelector('[data-product-submit]');
      const select = root.querySelector('[data-product-variant-select]');
      const price = root.querySelector('[data-product-price]');
      const comparePrice = root.querySelector('[data-product-compare-price]');
      const shippingNote = root.querySelector('[data-product-shipping-note]');
      const sticky = root.querySelector('[data-product-sticky]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const stickyAdd = root.querySelector('[data-sticky-add]');
      const packSwitch = form?.querySelector('[data-pack-switch]');
      const originalIdControl = form?.querySelector('[name="id"]');
      let packIdInput = null;

      const renderOffer = ({ value, cents, compare, available, pack = false }) => {
        if (value && price) price.textContent = value;
        if (value && stickyPrice) stickyPrice.textContent = value;
        if (comparePrice) {
          comparePrice.textContent = compare || '';
          comparePrice.classList.toggle('is-hidden', !compare);
        }
        if (shippingNote) {
          const threshold = Number(shippingNote.dataset.threshold || 5000);
          shippingNote.textContent = Number(cents || 0) >= threshold ? 'Livraison offerte' : 'Livraison calculée à l’étape suivante.';
        }
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available ? (pack ? 'Ajouter le Pack 01' : 'Ajouter au panier') : 'Épuisé';
        }
        if (stickyAdd) {
          stickyAdd.disabled = !available;
          stickyAdd.textContent = available ? (pack ? 'Ajouter le Pack 01' : 'Ajouter au panier') : 'Épuisé';
        }
      };

      const currentProductOffer = () => {
        if (select) {
          const option = select.options[select.selectedIndex];
          return { value: option?.dataset.price, cents: option?.dataset.priceCents, compare: option?.dataset.comparePrice, available: option?.dataset.available !== 'false' };
        }
        return {
          value: originalIdControl?.dataset.price || price?.textContent,
          cents: originalIdControl?.dataset.priceCents || 0,
          compare: originalIdControl?.dataset.comparePrice || '',
          available: originalIdControl?.dataset.available !== 'false'
        };
      };

      const syncVariant = () => {
        if (packSwitch?.checked) return;
        renderOffer(currentProductOffer());
      };
      select?.addEventListener('change', syncVariant);
      syncVariant();

      packSwitch?.addEventListener('change', () => {
        packSwitch.closest('.product-pack-switch')?.classList.toggle('is-selected', packSwitch.checked);
        if (packSwitch.checked) {
          if (originalIdControl) originalIdControl.disabled = true;
          packIdInput = document.createElement('input');
          packIdInput.type = 'hidden';
          packIdInput.name = 'id';
          packIdInput.value = packSwitch.dataset.packVariantId;
          packIdInput.dataset.packIdInput = 'true';
          form.appendChild(packIdInput);
          renderOffer({
            value: packSwitch.dataset.packPrice,
            cents: packSwitch.dataset.packPriceCents,
            compare: packSwitch.dataset.packComparePrice,
            available: true,
            pack: true
          });
        } else {
          packIdInput?.remove();
          packIdInput = null;
          if (originalIdControl) originalIdControl.disabled = false;
          renderOffer(currentProductOffer());
        }
      });

      stickyAdd?.addEventListener('click', () => submit?.click());

      if (sticky && submit && matchMedia('(max-width: 767px)').matches) {
        const updateSticky = () => {
          const rect = submit.getBoundingClientRect();
          const passed = rect.bottom < 86;
          sticky.classList.toggle('is-visible', passed);
          sticky.setAttribute('aria-hidden', String(!passed));
        };
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky, { passive: true });
        updateSticky();
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductUX);
  else initProductUX();
  document.addEventListener('shopify:section:load', initProductUX);
})();

/* V7 — zoom léger et propre sur les images produit */
(() => {
  const initProductZoom = () => {
    document.querySelectorAll('[data-main-product]').forEach(root => {
      if (root.dataset.adv4ZoomReady === 'true') return;
      root.dataset.adv4ZoomReady = 'true';
      const modal = root.querySelector('[data-product-zoom-modal]');
      const modalImg = root.querySelector('[data-product-zoom-image]');
      const close = root.querySelector('[data-product-zoom-close]');
      const stage = root.querySelector('[data-product-zoom-stage]');
      if (!modal || !modalImg) return;

      let startX = 0;
      let startY = 0;
      let moved = false;
      let previousFocus = null;

      const resetZoom = () => {
        modalImg.classList.remove('is-zoomed');
        modalImg.style.setProperty('--zoom-x','50%');
        modalImg.style.setProperty('--zoom-y','50%');
      };
      const open = trigger => {
        const src = trigger.dataset.zoomSrc;
        if (!src) return;
        previousFocus = document.activeElement;
        modalImg.src = src;
        modalImg.alt = trigger.dataset.zoomAlt || '';
        resetZoom();
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden','false');
        document.body.classList.add('product-zoom-open');
        close?.focus({preventScroll:true});
      };
      const shut = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden','true');
        document.body.classList.remove('product-zoom-open');
        resetZoom();
        modalImg.removeAttribute('src');
        previousFocus?.focus?.({preventScroll:true});
      };

      root.querySelectorAll('[data-product-zoom-trigger]').forEach(trigger => {
        trigger.addEventListener('pointerdown', e => { startX=e.clientX; startY=e.clientY; moved=false; });
        trigger.addEventListener('pointermove', e => { if(Math.abs(e.clientX-startX)>8 || Math.abs(e.clientY-startY)>8) moved=true; });
        trigger.addEventListener('click', e => {
          if (moved) return;
          e.preventDefault();
          open(trigger);
        });
        trigger.querySelector('[data-product-zoom-button]')?.addEventListener('click', e => {
          e.preventDefault(); e.stopPropagation(); open(trigger);
        });
      });

      close?.addEventListener('click', shut);
      modal.addEventListener('click', e => { if (e.target === modal) shut(); });
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && modal.classList.contains('is-open')) shut(); });

      modalImg.addEventListener('click', e => {
        if (!modalImg.classList.contains('is-zoomed')) {
          const r = modalImg.getBoundingClientRect();
          const x = ((e.clientX-r.left)/r.width)*100;
          const y = ((e.clientY-r.top)/r.height)*100;
          modalImg.style.setProperty('--zoom-x', `${Math.max(10,Math.min(90,x))}%`);
          modalImg.style.setProperty('--zoom-y', `${Math.max(10,Math.min(90,y))}%`);
          modalImg.classList.add('is-zoomed');
        } else resetZoom();
      });
      stage?.addEventListener('dblclick', e => e.preventDefault());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductZoom);
  else initProductZoom();
  document.addEventListener('shopify:section:load', initProductZoom);
})();
